var React = require('react');

function FbIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M13,10h3v3h-3v7h-3v-7H7v-3h3V8.745c0-1.189,0.374-2.691,1.118-3.512C11.862,4.41,12.791,4,13.904,4H16v3h-2.1   C13.402,7,13,7.402,13,7.899V10z"})));
}

FbIcon.defaultProps = {"baseProfile":"tiny","height":"24px","id":"Layer_1","version":"1.2","viewBox":"0 0 24 24","width":"24px","xmlSpace":"preserve"};

module.exports = FbIcon;

FbIcon.default = FbIcon;
